if (!customElements.get('open-menu')) {
  class OpenMenu extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      console.log('connectedCallback');
      const btn = this.querySelector('button');
      console.log(btn);
      const target = document.querySelector('.mobile-facets__open-wrapper');
      if (btn && target) {
        btn.addEventListener('click', function () {
          target.click();
        });
      }
    }
  }
  
  customElements.define('open-menu', OpenMenu);
}
